export default __webpack_public_path__ + "static/media/cientifica3.bf74fc82.jpg";